<template>

    <div>
    <template v-for="communityIteration in pCommunity">
        <md-checkbox v-model="mCommunity.partnerCommunities" :key="communityIteration._id"  class="partner-community-checkbox" :name="communityIteration._id" :value="communityIteration._id" v-if="communityIteration._id !== mCommunity._id"  >{{communityIteration.name}}</md-checkbox>
    </template>
    <md-button class="mt-20 md-raised md-round md-accent" type="submit">Save</md-button>
    </div>
</template>
<script>
import API from "../services/API";
export default {
  props: ["pCommunity", "mCommunity", "dataType"],
  data() {
  	return {
		  active: false,
		  api: new API(),
		  Load: this.isLoad
  	}
  }
};
</script>


// WEBPACK FOOTER //
// src/components/PartnerCommunityList.vue